import { render, staticRenderFns } from "./BrScoreCount.vue?vue&type=template&id=2915f543&scoped=true"
import script from "./BrScoreCount.vue?vue&type=script&lang=js"
export * from "./BrScoreCount.vue?vue&type=script&lang=js"
import style0 from "./BrScoreCount.vue?vue&type=style&index=0&id=2915f543&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2915f543",
  null
  
)

export default component.exports